import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { UserService } from '../service/user.service';

/**
 * Route guard that allows activation only when the loaded user holds the
 * permission named in `route.data['permission']`. It waits for the user to
 * load the same way {@link RouteGuard} does (`first(userId !== null)`), then
 * checks the exposed `permissions` array — never a role string. A caller
 * without the permission is redirected to the dashboard.
 *
 * Server-side enforcement remains the authorization boundary; this guard is a
 * usability aid (matching the nav-item gating in `MainNavComponent`).
 */
@Injectable()
export class PermissionGuard implements CanActivate {

  constructor(private userService: UserService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const required = route.data['permission'] as string;
    return this.userService.user$.pipe(
      first(user => user.userId !== null), // AI: wait for the user to be loaded
      map(user => user.permissions.includes(required) ? true : this.router.parseUrl('/'))
    );
  }
}
